// Mock data for Posh Signature Beauty Salon

export const services = [
  {
    id: 1,
    category: 'Nails',
    name: 'Professional Nail Services',
    description: 'Expert nail care and stunning finishes for hands and feet',
    price: 'From 20 AED',
    image: '/salon-nails-area.png',
    treatments: [
      { name: 'Express Manicure', price: '20 AED' },
      { name: 'Express Pedicure', price: '30 AED' },
      { name: 'Manicure', price: '45 AED' },
      { name: 'Pedicure', price: '65 AED' },
      { name: 'Gelish Polish', price: '50 AED' },
      { name: 'Hand Nail Paint', price: '20 AED' },
      { name: 'Feet Nail Paint', price: '20 AED' },
      { name: 'Gelish Mani Pedi', price: '169 AED' },
      { name: 'Glitz & Glam', price: '149 AED' }
    ]
  },
  {
    id: 2,
    category: 'Massage',
    name: 'Relaxation & Wellness Massage',
    description: 'Therapeutic massage treatments for complete relaxation',
    price: 'From 60 AED',
    image: '/salon-spa-area.png',
    treatments: [
      { name: 'Foot Massage (30 mins)', price: '60 AED' },
      { name: 'Head, Neck & Shoulder Massage (1 hr)', price: '80 AED' },
      { name: 'Back Massage (30 mins)', price: '60 AED' },
      { name: 'Callus Treatment', price: '40 AED' },
      { name: '4X Massage Session Package', price: '500 AED' }
    ]
  },
  {
    id: 3,
    category: 'Waxing',
    name: 'Premium Waxing Services',
    description: 'Smooth, silky skin with professional waxing treatments',
    price: 'From 25 AED',
    image: '/waxing-service.jpeg',
    treatments: [
      { name: 'Full Arms', price: '45 AED' },
      { name: 'Full Legs', price: '55 AED' },
      { name: 'Underarms', price: '25 AED' },
      { name: 'Bikini', price: '75 AED' },
      { name: 'Full Stomach', price: '40 AED' },
      { name: 'Full Back', price: '50 AED' }
    ]
  },
  {
    id: 4,
    category: 'Skin',
    name: 'Radiant Skin Treatments',
    description: 'Reveal your natural glow with our customized treatments',
    price: 'From 35 AED',
    image: 'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9',
    treatments: [
      { name: 'Luxe Glow Infusion', price: '250 AED' },
      { name: 'Bleach', price: '35 AED' },
      { name: 'Full Face Threading', price: '60 AED' },
      { name: 'Full Face Wax', price: '65 AED' },
      { name: 'Eyebrow & Upperlip', price: '35 AED' },
      { name: 'Chin Threading', price: '20 AED' }
    ]
  },
  {
    id: 5,
    category: 'Bridal',
    name: 'Bridal Perfection',
    description: 'Look absolutely stunning on your special day',
    price: 'From 200 AED',
    image: 'https://images.unsplash.com/photo-1684868268327-7e5590bcfbd6',
    treatments: [
      { name: 'Bridal Makeup', price: '1,000 AED' },
      { name: 'Bridal Hair Style', price: '200 AED' },
      { name: 'Bridal Mehndi', price: '800 AED' },
      { name: 'Complete Bridal Package', price: '999 AED' }
    ]
  }
];

export const offers = [
  {
    id: 1,
    title: 'Lash Lift',
    description: 'Get beautifully lifted lashes - No extensions, No mascara needed! Before: straight natural lashes → After: perfectly lifted lashes.',
    discount: 'AED 85',
    validUntil: 'Book Now',
    image: '/offer-lash-lift.jpg',
    featured: true
  },
  {
    id: 2,
    title: 'Eyelash Extension',
    description: 'Transform your look with stunning eyelash extensions for a glamorous, fuller lash look.',
    discount: 'AED 99',
    validUntil: 'Book Now',
    image: '/offer-eyelash-extension.jpg',
    featured: true
  },
  {
    id: 3,
    title: 'Eyebrow Lamination',
    description: 'Brow Game Elevated! Get perfectly lifted, fuller-looking brows. No makeup needed, smooths unruly hairs, results last up to 8 weeks.',
    discount: 'AED 50',
    validUntil: 'Schedule Your Session',
    image: '/offer-eyebrow-lamination.jpg',
    featured: true
  },
  {
    id: 4,
    title: 'Ice Hair Spa',
    description: 'Limited Time Offer! Experience the ultimate cooling hair spa treatment for healthier, shinier, and softer hair. Refresh • Nourish • Revive',
    discount: 'AED 45',
    originalPrice: 'AED 60',
    validUntil: 'Limited Time',
    image: '/offer-ice-hair-spa.jpg',
    featured: true
  },
  {
    id: 5,
    title: 'Ayurvedic Banana Leaf Hair Treatment',
    description: '90 Minutes of Pure Hair Therapy! Includes: Scalp Massage, Banana Leaf Hair Mask, Steam Therapy, Hair Wash, Face Mask & Serum Finish. 100% Natural, No Harsh Chemicals.',
    discount: 'AED 200',
    validUntil: 'Book Now',
    image: '/offer-ayurvedic-banana-leaf.jpg',
    featured: true
  },
  {
    id: 6,
    title: 'The Gel Express',
    description: 'Gel Manicure + Gel Pedicure - Long-lasting shine and elegance!',
    discount: 'AED 169',
    validUntil: 'Limited Time Offer',
    image: '/gel-express-offer.jpeg',
    featured: false
  },
  {
    id: 7,
    title: 'Pick Any 9 Services Package',
    description: 'Choose any 9 services from our extensive menu - Amazing value!',
    discount: 'Only AED 300',
    validUntil: 'Book Now',
    image: '/pick-9-services.jpeg',
    featured: false
  },
  {
    id: 8,
    title: 'Glitz & Glam',
    description: 'Gel Manicure + Classic Pedicure combo',
    discount: 'AED 149',
    validUntil: 'Ongoing Offer',
    image: '/glitz-glam-offer.jpeg',
    featured: false
  },
  {
    id: 9,
    title: 'Relax. Recharge. Repeat. - Spa Sale',
    description: '4x Massage Sessions - Perfect wellness package for ultimate relaxation',
    discount: 'AED 500',
    validUntil: 'Special Package',
    image: '/spa-massage-offer.jpeg',
    featured: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    rating: 5,
    comment: 'Absolutely loved my bridal makeup! The team is so professional and the ambiance is perfect. Highly recommend!',
    service: 'Bridal Makeup'
  },
  {
    id: 2,
    name: 'Ananya Reddy',
    rating: 5,
    comment: 'Best facial I have ever had! My skin is glowing. The privacy and luxury feel is exactly what I was looking for.',
    service: 'Hydra Facial'
  },
  {
    id: 3,
    name: 'Sneha Patel',
    rating: 5,
    comment: 'The spa experience was divine! Such attention to detail and care. I feel completely rejuvenated.',
    service: 'Spa Package'
  },
  {
    id: 4,
    name: 'Kavya Menon',
    rating: 5,
    comment: 'Love coming here for my regular manicures. The nail art is stunning and the service is top-notch!',
    service: 'Nail Art'
  }
];

export const galleryImages = [
  {
    id: 1,
    url: '/salon-exterior.png',
    category: 'Salon',
    title: 'Posh Signature Exterior'
  },
  {
    id: 2,
    url: '/salon-hair-area.png',
    category: 'Hair',
    title: 'Hair Styling Area'
  },
  {
    id: 3,
    url: '/salon-spa-area.png',
    category: 'Spa',
    title: 'Luxury Spa & Pedicure Area'
  },
  {
    id: 4,
    url: '/salon-nails-area.png',
    category: 'Nails',
    title: 'Professional Nails Section'
  },
  {
    id: 5,
    url: 'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9',
    category: 'Skin',
    title: 'Luxury Facial Treatment'
  },
  {
    id: 6,
    url: 'https://images.unsplash.com/photo-1758739010986-cbcd556b34ec',
    category: 'Bridal',
    title: 'Bridal Makeup Application'
  },
  {
    id: 7,
    url: 'https://images.unsplash.com/photo-1684868268327-7e5590bcfbd6',
    category: 'Bridal',
    title: 'Bridal Perfection'
  },
  {
    id: 8,
    url: 'https://images.unsplash.com/photo-1632345031435-8727f6897d53',
    category: 'Nails',
    title: 'Professional Manicure'
  }
];

export const salonInfo = {
  name: 'Posh Signature Beauty Salon',
  tagline: 'Where Elegance Meets Excellence',
  phone: '+971 04 358 0313',
  whatsapp: '+971551182969',
  alternatePhone: '+971 55 118 2969',
  email: 'poshsignaturebeautysalon@gmail.com',
  address: '09, Karama New Building, 8A St, Ansar Gallery, Karama, Dubai - UAE',
  hours: {
    monday: 'Closed',
    tuesday: '10:00 AM - 9:00 PM',
    wednesday: '10:00 AM - 9:00 PM',
    thursday: '10:00 AM - 9:00 PM',
    friday: '12:00 PM - 9:00 PM',
    saturday: '10:00 AM - 9:00 PM',
    sunday: '10:00 AM - 9:00 PM'
  },
  social: {
    instagram: 'https://www.instagram.com/poshsignaturesalon',
    facebook: 'https://facebook.com/poshsignature',
    youtube: 'https://youtube.com/poshsignature'
  }
};

export const products = [
  {
    id: 1,
    name: 'K Therapy Purifying Balancing Shampoo',
    description: 'Professional balancing shampoo for oily hair',
    category: 'Oily Hair',
    price: '85 AED',
    image: '/k-therapy-purifying-shampoo.jpeg',
    brand: 'Lakmé'
  },
  {
    id: 2,
    name: 'K Therapy Purifying Matt Mask',
    description: 'Premium matt mask treatment for oily hair',
    category: 'Oily Hair',
    price: '150 AED',
    image: '/k-therapy-purifying-mask.jpeg',
    brand: 'Lakmé'
  },
  {
    id: 3,
    name: 'K Therapy Peeling Shampoo',
    description: 'Anti-dandruff peeling shampoo for oily hair',
    category: 'Dandruff & Oily Hair',
    price: '75 AED',
    image: '/k-therapy-peeling-shampoo-oily.jpeg',
    brand: 'Lakmé'
  },
  {
    id: 4,
    name: 'K Therapy Peeling Shock Gel',
    description: 'Intensive anti-dandruff shock gel treatment',
    category: 'Dandruff & Oily Hair',
    price: '150 AED',
    image: '/k-therapy-peeling-shock-gel-new.jpeg',
    brand: 'Lakmé'
  },
  {
    id: 5,
    name: 'K Therapy Repair Revitalizing Shampoo',
    description: 'Revitalizing shampoo for dry and damaged hair',
    category: 'Dry Hair',
    price: '65 AED',
    image: '/k-therapy-repair-shampoo.jpeg',
    brand: 'Lakmé'
  },
  {
    id: 6,
    name: 'K Therapy Repair Conditioning Fluid',
    description: 'Nourishing conditioning fluid for dry hair',
    category: 'Dry Hair',
    price: '65 AED',
    image: '/k-therapy-repair-conditioning-fluid.jpeg',
    brand: 'Lakmé'
  },
  {
    id: 7,
    name: 'K Therapy Repair Concentrate',
    description: 'Intensive repair concentrate for dry hair',
    category: 'Dry Hair',
    price: '150 AED',
    image: '/k-therapy-repair-concentrate.jpeg',
    brand: 'Lakmé'
  },
  {
    id: 8,
    name: 'K Therapy Repair Nourishing Mask',
    description: 'Deep nourishing mask for dry hair',
    category: 'Dry Hair',
    price: '75 AED',
    image: '/k-therapy-repair-nourishing-mask.jpeg',
    brand: 'Lakmé'
  },
  {
    id: 9,
    name: 'K Therapy Repair Repairing Gel',
    description: 'Professional repairing gel for dry hair',
    category: 'Dry Hair',
    price: '120 AED',
    image: '/k-therapy-repair-repairing-gel.jpeg',
    brand: 'Lakmé'
  },
  {
    id: 10,
    name: 'Hair Care White Silver Mask',
    description: 'Brightening mask for blonde, highlights & white hair. Vegan, paraben-free formula.',
    category: 'Color Treated Hair',
    price: '80 AED',
    image: '/teknia-white-silver-mask.jpeg',
    brand: 'Teknia'
  },
  {
    id: 11,
    name: 'Hair Care Color Stay Shampoo',
    description: 'Protection shampoo for color-treated hair. Vegan, sulfate-free formula.',
    category: 'Color Treated Hair',
    price: '85 AED',
    image: '/teknia-color-stay-shampoo-new.jpeg',
    brand: 'Teknia'
  },
  {
    id: 12,
    name: 'Hair Care Color Stay Conditioner',
    description: 'Protection conditioner for color-treated hair. Vegan, paraben-free formula.',
    category: 'Color Treated Hair',
    price: '80 AED',
    image: '/teknia-color-stay-conditioner-new.jpeg',
    brand: 'Teknia'
  },
  {
    id: 37,
    name: 'Hair Care White Silver Shampoo',
    description: 'Toning shampoo for blonde, highlights & white hair. Vegan, paraben-free formula.',
    category: 'Color Treated Hair',
    price: '100 AED',
    image: '/teknia-white-silver-shampoo.jpeg',
    brand: 'Teknia'
  },
  {
    id: 13,
    name: 'Hair Care Organic Balance Shampoo',
    description: 'Hydra shampoo with 93% derived natural ingredients. Vegan, sulfate-free formula.',
    category: 'Organic & Natural',
    price: '95 AED',
    image: '/teknia-organic-balance-shampoo.jpeg',
    brand: 'Teknia'
  },
  {
    id: 14,
    name: 'Hair Care Organic Balance Mask',
    description: 'Organic balance treatment mask. Vegan, natural formula.',
    category: 'Organic & Natural',
    price: '110 AED',
    image: '/teknia-organic-balance-mask.jpeg',
    brand: 'Teknia'
  },
  {
    id: 15,
    name: 'Hair Care Full Defense Serum',
    description: 'Protective serum for stressed hair. Vegan, paraben-free formula.',
    category: 'Hair Protection',
    price: '50 AED',
    image: '/teknia-full-defense-serum.jpeg',
    brand: 'Teknia'
  },
  {
    id: 16,
    name: 'Hair Care Full Defense Shampoo',
    description: 'Protective shampoo for stressed hair. Vegan, paraben-free formula.',
    category: 'Hair Protection',
    price: '75 AED',
    image: '/teknia-full-defense-shampoo.jpeg',
    brand: 'Teknia'
  },
  {
    id: 17,
    name: 'Hair Care Full Defense Treatment',
    description: 'Full defense treatment for damaged hair. Vegan formula.',
    category: 'Hair Protection',
    price: '95 AED',
    image: '/teknia-full-defense-treatment.jpeg',
    brand: 'Teknia'
  },
  {
    id: 18,
    name: 'Scalp Care VITAL Shampoo',
    description: 'Stimulating shampoo for hair loss. 93% natural ingredients, vegan formula.',
    category: 'Hair Loss Treatment',
    price: '80 AED',
    image: '/teknia-scalp-care-vital-shampoo.jpeg',
    brand: 'Teknia'
  },
  {
    id: 19,
    name: 'Scalp Care VITAL Lotion',
    description: 'Stimulating lotion for hair loss. 99% natural ingredients, vegan formula.',
    category: 'Hair Loss Treatment',
    price: '95 AED',
    image: '/teknia-scalp-care-vital-lotion.jpeg',
    brand: 'Teknia'
  },
  {
    id: 20,
    name: 'Scalp & Hair Care Pro Ageing Shampoo',
    description: 'Renewal shampoo for all hair types & scalp. Vegan formula.',
    category: 'Anti-Ageing',
    price: '90 AED',
    image: '/teknia-pro-ageing-shampoo.jpeg',
    brand: 'Teknia'
  },
  {
    id: 21,
    name: 'Pro Ageing Mask',
    description: 'Anti-ageing treatment mask for all hair types. Vegan formula.',
    category: 'Anti-Ageing',
    price: '115 AED',
    image: '/teknia-pro-ageing-mask.jpeg',
    brand: 'Teknia'
  },
  {
    id: 22,
    name: 'Hair Care Argan Oil Shampoo',
    description: 'Hydrating shampoo for normal to dry hair. Vegan, sulfate-free formula.',
    category: 'Argan Oil',
    price: '115 AED',
    image: '/teknia-argan-oil-shampoo.jpeg',
    brand: 'Teknia'
  },
  {
    id: 23,
    name: 'Argan Oil Treatment',
    description: 'Nourishing argan oil treatment for normal to dry hair.',
    category: 'Argan Oil',
    price: '100 AED',
    image: '/teknia-argan-oil-treatment.jpeg',
    brand: 'Teknia'
  },
  {
    id: 24,
    name: 'Hair Care Argan Oil (Dry Oil)',
    description: 'Nourishing protective dry oil for normal to dry hair. Vegan, paraben-free.',
    category: 'Argan Oil',
    price: '100 AED',
    image: '/teknia-argan-oil-dry-oil.jpeg',
    brand: 'Teknia'
  },
  {
    id: 25,
    name: 'Hair Care Body Maker Shampoo',
    description: 'Volume shampoo for fine hair. Vegan, paraben-free formula.',
    category: 'Volume & Fine Hair',
    price: '85 AED',
    image: '/teknia-body-maker-shampoo.jpeg',
    brand: 'Teknia'
  },
  {
    id: 26,
    name: 'Hair Care Body Maker Mist',
    description: 'Volumizing spray for fine hair. Vegan, paraben-free formula.',
    category: 'Volume & Fine Hair',
    price: '75 AED',
    image: '/teknia-body-maker-mist.jpeg',
    brand: 'Teknia'
  },
  {
    id: 27,
    name: 'Hair Care Body Maker Balm',
    description: 'Lightweight volume balm for fine hair. Vegan formula.',
    category: 'Volume & Fine Hair',
    price: '75 AED',
    image: '/teknia-body-maker-balm.jpeg',
    brand: 'Teknia'
  },
  {
    id: 28,
    name: 'Hair Care Metal Remover Protector Mist',
    description: 'Moisturizing lotion for all hair types. Vegan formula.',
    category: 'Metal Remover',
    price: '85 AED',
    image: '/teknia-metal-remover-mist.jpeg',
    brand: 'Teknia'
  },
  {
    id: 29,
    name: 'Hair Care Metal Remover Hydra Shampoo',
    description: 'Moisturizing-detox shampoo for all hair types. Vegan formula.',
    category: 'Metal Remover',
    price: '90 AED',
    image: '/teknia-metal-remover-shampoo.jpeg',
    brand: 'Teknia'
  },
  {
    id: 30,
    name: 'Hair Care Metal Remover Hydra Conditioner',
    description: 'Moisturizing-detox conditioner for all hair types. Vegan formula.',
    category: 'Metal Remover',
    price: '125 AED',
    image: '/teknia-metal-remover-conditioner.jpeg',
    brand: 'Teknia'
  },
  {
    id: 31,
    name: 'Hair Care Deep Care Shampoo',
    description: 'Restoring shampoo for damaged hair. Vegan, paraben-free formula.',
    category: 'Deep Care',
    price: '75 AED',
    image: '/teknia-deep-care-shampoo.jpeg',
    brand: 'Teknia'
  },
  {
    id: 32,
    name: 'Hair Care Deep Care Conditioner',
    description: 'Restoring conditioner for damaged hair. Vegan, paraben-free formula.',
    category: 'Deep Care',
    price: '95 AED',
    image: '/teknia-deep-care-conditioner.jpeg',
    brand: 'Teknia'
  },
  {
    id: 33,
    name: 'Hair Care Frizz Control Shampoo',
    description: 'Discipline shampoo for frizzy hair. Vegan, sulfate-free formula.',
    category: 'Frizz Control',
    price: '85 AED',
    image: '/teknia-frizz-control-shampoo.jpeg',
    brand: 'Teknia'
  },
  {
    id: 34,
    name: 'Hair Care Frizz Control Conditioner',
    description: 'Discipline conditioner for frizzy hair. Vegan, paraben-free formula.',
    category: 'Frizz Control',
    price: '95 AED',
    image: '/teknia-frizz-control-conditioner.jpeg',
    brand: 'Teknia'
  },
  {
    id: 35,
    name: 'Hair Care Cocoa Brown Shampoo',
    description: 'Color refresh shampoo for brown color-treated hair. Vegan formula.',
    category: 'Color Refresh',
    price: '75 AED',
    image: '/teknia-cocoa-brown-shampoo-new.jpeg',
    brand: 'Teknia'
  },
  {
    id: 36,
    name: 'Hair Care Cocoa Brown Mask',
    description: 'Color refresh mask for brown color-treated hair. Vegan, paraben-free.',
    category: 'Color Refresh',
    price: '80 AED',
    image: '/teknia-cocoa-brown-mask-new.jpeg',
    brand: 'Teknia'
  },
  {
    id: 38,
    name: 'Scalp Care Detox Shampoo',
    description: 'Balance shampoo for dandruff. 94% natural ingredients, vegan formula.',
    category: 'Dandruff Treatment',
    price: '220 AED',
    image: '/teknia-scalp-care-detox-shampoo.jpeg',
    brand: 'Teknia'
  },
  {
    id: 39,
    name: 'Scalp Care Detox Gel',
    description: 'Balance scrub for dandruff. 96% natural ingredients, vegan formula.',
    category: 'Dandruff Treatment',
    price: '100 AED',
    image: '/teknia-scalp-care-detox-gel.jpeg',
    brand: 'Teknia'
  },
  {
    id: 40,
    name: 'Hair Care Deep Care Drops',
    description: 'Restoring serum for split-ends. Vegan, paraben-free formula.',
    category: 'Deep Care',
    price: '70 AED',
    image: '/teknia-deep-care-drops.jpeg',
    brand: 'Teknia'
  }
];
